import { Component, Input, OnInit } from '@angular/core';
import * as moment from 'moment';
import { FiltroDataComponent } from '../../../../shared/filtro-data/filtro-data.component';
import { FiltroService } from '../../../../shared/filtro/filtro.service';
import { FormatarData } from '../../../../shared/formatarData';

@Component({
  selector: 'app-produtividade-filtro',
  templateUrl: './produtividade-filtro.component.html',
  styleUrls: ['./produtividade-filtro.component.css']
})
export class ProdutividadeFiltroComponent implements OnInit {
  Mercado: any;

  @Input() filtros: any;

  gruposEconomicos = [];
  regioes = [];
  dealers = [];
  Sysdate: FiltroDataComponent = new FiltroDataComponent;
  InicialData; // Set the first Day of month
  FinalData; // set the last day of query
  max;       // Set a valid date

  constructor(private servico: FiltroService) {

    const max = new Date();
    this.max = { 'year': max.getFullYear(), 'month': max.getMonth() + 1, 'day': max.getUTCDate() };


    this.InicialData = moment(this.InicialData).startOf('month').format('YYYY-MM-DD');
    this.FinalData = moment(this.FinalData).format('YYYY-MM-DD');

  }

  ngOnInit() {
    this.preencherGruposEconomicos();
    this.preencherRegioes();
    this.preencherDealers();
  }


  preencherGruposEconomicos() {
    this.servico.buscar('grupo_economico').then(r => { this.gruposEconomicos = r.filtros; });
  }

  preencherRegioes() {
    this.servico.buscar('regiao').then(r => { this.regioes = r.filtros; });
  }

  preencherDealers() {
    if (this.GrupoEconomico !== '') {
      this.servico.buscar('dealerGrupo/'.concat(this.GrupoEconomico)).then(r => { this.dealers = r.filtros; });
    } else {
      this.servico.buscarDealer('dealer').then(r => { this.dealers = r.filtros; });
    }
  }

  selecionaDealer() {
    this.dealers = [];
    this.preencherDealers();
  }

  set GrupoEconomico(id: any) { this.filtros.grupo_economico = this.tratarSetDropDown(id); }
  get GrupoEconomico(): any { return this.tratarGetDropDown(this.filtros.grupo_economico); }

  set Regiao(id: any) { this.filtros.regiao = this.tratarSetDropDown(id); }
  get Regiao(): any { return this.tratarGetDropDown(this.filtros.regiao); }

  set Dealer(id: any) { this.filtros.dealer = this.tratarSetDropDown(id); }
  get Dealer(): any { return this.tratarGetDropDown(this.filtros.dealer); }

  set DataInicial(data) { this.filtros.data_inicial = this.getDataString(data); }
  get DataInicial(): any { return this.tratarGetDropDown(this.filtros.data_inicial); }

  set DataFinal(data) { this.filtros.data_final = this.getDataString(data); }
  get DataFinal(): any { return this.tratarGetDropDown(this.filtros.data_final); }

  tratarSetDropDown(id: string): number {
    if (id) {
      return +id;
    } else {
      return null;
    }
  }

  tratarGetDropDown(selecionado: any): string {
    if (selecionado === null || selecionado === undefined) {
      return '';
    }
    return selecionado;
  }

  set dataInicial(data) {
    this.filtros.data_inicial = this.getDataString(data);
  }

  set dataFinal(data) {
    this.filtros.data_final = this.getDataString(data);
  }

  limparDataInicial(dataInicialView) {
    dataInicialView._elRef.nativeElement.value = '';
    this.filtros.data_inicial = '';
  }

  limparDataFinal(dataFinalView) {
    dataFinalView._elRef.nativeElement.value = '';
    this.filtros.data_final = '';
  }

  getDataString(data): any {
    return new FormatarData(data.year, data.month, data.day, 0, 0, 0).getDataString();
  }

}

